import { Tooltip as MUITooltip } from '@mui/material';
import classNames from 'classnames';
import { FC, ReactNode, useState } from 'react';

import classes from './Tooltip.module.scss';

export interface TooltipProps {
  tooltipText: string;
  placement?:
    | 'top'
    | 'bottom-end'
    | 'bottom-start'
    | 'bottom'
    | 'left-end'
    | 'left-start'
    | 'left'
    | 'right-end'
    | 'right-start'
    | 'right'
    | 'top-end'
    | 'top-start';
  disabled?: boolean;
  open?: boolean;
  className?: string;
  children?: ReactNode;
}

const Tooltip: FC<TooltipProps> = ({
  tooltipText,
  children,
  placement = 'top',
  disabled = false,
  open: forceOpen = false,
  className,
}) => {
  const [open, setOpen] = useState(false);

  return (
    <MUITooltip
      classes={{
        tooltip: classNames(classes.Tooltip, className),
        popper: classes.Popper,
      }}
      title={tooltipText}
      arrow
      placement={placement}
      open={forceOpen || open}
      onOpen={!disabled ? () => setOpen(true) : undefined}
      onClose={() => setOpen(false)}
    >
      <div>{children}</div>
    </MUITooltip>
  );
};

export default Tooltip;
